/** @jsx jsx */
import * as React from "react";
import { css, jsx } from "@emotion/core";
import { ModalComponent } from "../ModalComponent";
import CTA, { CTATheme } from "../common/CallToAction";
import AppUtils from "../../utils/AppUtils";
import { rosterButtonStyles } from "../../styles/components/Roster/RosterCalendar";

interface IDefaultWorkingConfirmationModalProps {
    editShifts: () => void;
    saveShifts: () => void;
    effectiveDate: string;
}

export const DefaultWorkingConfirmationModal = (props: IDefaultWorkingConfirmationModalProps) => {
    const [shouldDisable, setDisable] = React.useState(false);
    const isMobile: boolean = AppUtils.getIsMobile();
    const preventModalClose = (e: React.MouseEvent<HTMLDivElement>): void => {
        e.preventDefault();
        e.stopPropagation();
    }

    const saveShifts = () => {
        setDisable(true);
        props.saveShifts()
    }

    return (
        <div className="roster-modal-container">
            <ModalComponent modalSize="x-small">
                <div onClick={preventModalClose}>
                    <div className="roster-modal-header">
                        <h3>Confirmation</h3>
                    </div>
                    <hr></hr>
                    <div className="roster-modal-body">
                        Applied hours will be effective from {props.effectiveDate} onwards. Do you want to continue?
                    </div>
                    <hr></hr>
                    <div className={`roster-modal-footer ${isMobile && "align-btn"}`}>
                        <CTA innerText="Go Back" theme={CTATheme.LIGHT} onClick={props.editShifts} disabled={shouldDisable} customStyle={rosterButtonStyles} />
                        <CTA innerText="Proceed" disabled={shouldDisable} theme={CTATheme.PRIMARY} onClick={saveShifts} customStyle={rosterButtonStyles} />
                    </div>
                </div>
            </ModalComponent>
        </div>
    )
}
